<tyt-poll [mini]="true" [poll]="poll" [expectedType]="expectedType"></tyt-poll>